module.exports = __webpack_public_path__ + "static/img/3.188206b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/hrm/3.png
// module id = D8O6
// module chunks = 0